import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { syncQueue, onSyncEvent } from './offline/sync';
import { getQueueCount, getQueue, removeQueue } from './offline/db';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Never block the first render on offline synchronization.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js', { scope: '/' })
      .catch(err => console.warn('Service Worker registration failed:', err));
  });
}

// Sync is manual only (triggered by the person via the "Sync Now" bar in
// public/index.html) — nothing is pushed/pulled automatically on load or on
// reconnect, so it never runs against a still-settling network connection.
window.pharmaSync = {
  runSync: () => syncQueue(),
  getQueueCount: () => getQueueCount(),
  // queued changes the server rejected, with the server's reason
  // forget queued changes the server rejected (only ever on the person's explicit request)
  discardFailed: async () => { const rows = (await getQueue()).filter(r => r.lastError); for (const r of rows) await removeQueue(r.id); return rows.length; },
  getFailed: async () => (await getQueue()).filter(r => r.lastError).map(r => ({ url: r.url, method: r.method, error: r.lastError })),
  onSyncEvent,
};
